/* Bandenmeesters header: native account/search, canonical garage and decorative wheel. */
(()=>{
  if(window.__bmHeaderRuntime)return;
  window.__bmHeaderRuntime=true;
  const desktop=window.matchMedia('(min-width: 990px)');
  let config={},resizeObserver=null,wheelSequence=0;
  const normaliseBrand=(value='')=>String(value).trim().toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'-');

  const syncVehicleWheel=()=>{
    const stage=document.querySelector('[data-bm-header-wheel-stage]');
    if(!stage)return;
    stage.hidden=!desktop.matches;
    if(stage.hidden)return;
    const active=window.BandenmeestersVehicle?.getActive?.();
    const url=config.brandWheels?.[normaliseBrand(active?.brand?.name)]||'';
    if(stage.dataset.wheelUrl===url)return;
    stage.dataset.wheelUrl=url;
    const sequence=++wheelSequence;
    if(!url){
      stage.classList.remove('has-wheel');
      stage.querySelectorAll('img').forEach(image=>{image.classList.remove('is-active');image.removeAttribute('src')});
      return;
    }
    const next=stage.querySelector('img:not(.is-active)');
    if(!next)return;
    next.onload=()=>{
      if(sequence!==wheelSequence||!stage.isConnected||stage.dataset.wheelUrl!==url)return;
      stage.querySelectorAll('img').forEach(image=>image.classList.toggle('is-active',image===next));
      stage.classList.add('has-wheel');
    };
    next.onerror=()=>{
      if(sequence!==wheelSequence||!stage.isConnected)return;
      stage.dataset.wheelUrl='';
      stage.classList.remove('has-wheel');
    };
    next.src=url;
  };

  // Header-only consumer of the single canonical Mijn Auto state.
  // Never create a second garage store or change the selected vehicle.
  const syncHeaderGarage=()=>{
    const chip=document.querySelector('#header [data-bm-header-garage]');
    if(!chip)return;
    const api=window.BandenmeestersVehicle;
    if(!api?.getActive)return;
    const active=api.getActive();
    const title=chip.querySelector('[data-bm-header-garage-title]');
    const meta=chip.querySelector('[data-bm-header-garage-meta]');
    let name='Mijn auto';
    let detail='Kies je auto';
    let fullLabel='Kies je auto';
    if(active){
      const brand=active.brand?.name||active.newVehicle?.brandLabel||'';
      const model=active.model?.name||active.newVehicle?.modelLabel||'';
      name=[brand,model].filter(Boolean).join(' ')||'Mijn auto';
      detail=api.vehicleMeta?.(active)||'Wijzig auto';
      fullLabel=api.vehicleLabel?.(active)||[name,detail].filter(Boolean).join(' ');
    }
    if(title)title.textContent=name;
    if(meta)meta.textContent=detail;
    chip.dataset.bmHeaderGarageState=active?'selected':'empty';
    const accessibleLabel=active?'Wijzig auto: '+fullLabel:'Kies je auto';
    chip.setAttribute('aria-label',accessibleLabel);
    chip.title=accessibleLabel;
    chip.hidden=false;
  };
  const syncVehicleDisplay=()=>{syncVehicleWheel();syncHeaderGarage()};

  const measureHeader=()=>{
    const header=document.querySelector('#header');
    if(!header)return;
    const height=Math.ceil(header.getBoundingClientRect().height);
    if(height>0)document.documentElement.style.setProperty('--bm-header-sticky-offset',`${height}px`);
  };

  const refresh=()=>{
    const node=document.getElementById('bm-header-config');
    try{config=JSON.parse(node?.textContent||'{}')}catch(_){config={}}
    resizeObserver?.disconnect();
    const header=document.querySelector('#header');
    if(header&&'ResizeObserver'in window){
      resizeObserver=new ResizeObserver(measureHeader);
      resizeObserver.observe(header);
    }
    measureHeader();
    syncVehicleDisplay();
  };
  const boot=()=>{
    refresh();
    if(!('ResizeObserver'in window))window.addEventListener('resize',measureHeader,{passive:true});
    desktop.addEventListener('change',syncVehicleWheel);
    window.addEventListener('pageshow',refresh);
    window.addEventListener('bm:vehicle:change',syncVehicleDisplay);
    document.addEventListener('bm:vehicle:ready',syncVehicleDisplay);
    document.addEventListener('shopify:section:load',refresh);
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.querySelector?.('#header')){resizeObserver?.disconnect();++wheelSequence}
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
